import MapLayerToolView from "lib/enums/maplayertoolview";

export function getViewModeClassname(viewMode:MapLayerToolView):string {
	switch(viewMode) {
		case MapLayerToolView.Rows:
			return "--rows";
		case MapLayerToolView.Grid:
			return "--grid";
		case MapLayerToolView.GridSmall: 
			return "--grid layer-groups--grid-small";
	}
	return "";
}
export function getViewModeContainerName(viewMode:MapLayerToolView):string {
	switch(viewMode) {
		case MapLayerToolView.Rows:
			return "--rows";
		case MapLayerToolView.Grid:
		case MapLayerToolView.GridSmall:
			return "--grid";
	}
	return "";
}